export default {"src":"/_next/static/media/tik-tok-logo-hover.f23f517e.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};